import Loadable from 'react-loadable'
import Loading from '../../components/Loading/Loading'

export default function LazyLoad(opts, shouldShowLoading) {
  return Loadable(
    Object.assign(
      {
        loading: () => (shouldShowLoading ? <Loading /> : null),
        delay: 200,
        timeout: 10000,
      },
      opts
    )
  )
}
